import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga'
import dataSaga from './sagas'
import g2pApp from './reducers';

const sagaMiddleware = createSagaMiddleware()

// add Redux dev tools to browser window
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// create Redux store with dev tools, app reducer and redux-saga
export default function configureStore() {
  let store = createStore(g2pApp, composeEnhancers(
    applyMiddleware(sagaMiddleware)
  ));
  sagaMiddleware.run(dataSaga);
  return store
}



// WEBPACK FOOTER //
// ./src/createstore.js